export default "/images/vendor/flag-icon-css/flags/1x1/bh.svg?b3fd5b17b2c1070ca61a1cf2b088ad8b";